import proj4 from 'proj4'
import OlMap from 'ol/Map'
import OlView from 'ol/View'
import OlProjection from 'ol/proj/Projection'
import OlLayerTile from 'ol/layer/Tile'
import OlLayerImage from 'ol/layer/Image'
import OlSourceImageWMS from 'ol/source/ImageWMS'
import OlFormatGeoJSON from 'ol/format/GeoJSON'
import OlFormatWMTSCapabilities from 'ol/format/WMTSCapabilities'
import OlSourceVector from 'ol/source/Vector'
import OlSourceWMTS, { optionsFromCapabilities } from 'ol/source/WMTS'
import OlStyle from 'ol/style/Style'
import OlStyleIcon from 'ol/style/Icon'
import OlStroke from 'ol/style/Stroke'
import OlCircle from 'ol/style/Circle'
import OlFill from 'ol/style/Fill'
import { register } from 'ol/proj/proj4'
import LayerSwitcher from 'ol-layerswitcher'
import Popup from 'ol-popup'
import { isNullOrUndefined, functionExist, getEl } from 'cgil-html-utils'
import OlLayerVector from 'ol/layer/Vector'
import OlFeature from 'ol/Feature'
import OlPoint from 'ol/geom/Point'
import { DEV, getLog, BASE_PATH } from '../config'
import { arrBoolToHex } from './tools'

import './ol.css'
import './ol-layerswitcher.css'
import './ol-popup.css'

const MODULE_NAME = 'ol-lausanne-map-mn95'
const log = getLog(MODULE_NAME, 4, 4)
// const PFP3_314 = [2538008.374, 1151705.117]; // MN03 Y=538'008.790 X=151'704.680
// const PFP3_1322 = [2534664.684, 1152646.677]; // MN03 Y=534'665.120 X=152'646.210
// const PFP3_3823 = [2535025.023, 1152846.991]; // MN03 Y=534'665.120 X=152'646.210

const baseWmsUrl = DEV ? 'https://map.lausanne.ch/mapserv_proxy?' : 'https://map.lausanne.ch/mapserv_proxy?'
const urlASITVD = 'https://ows.asitvd.ch/wmts/1.0.0/WMTSCapabilities.xml'
const urlSWISSTOPO = 'https://wmts.geo.admin.ch/EPSG/2056/1.0.0/WMTSCapabilities.xml?lang=fr'
const urlLausanneMN95 = 'https://tilesmn95.lausanne.ch/tiles/1.0.0/LausanneWMTS.xml'
const defaultBaseLayer = 'fonds_geo_osm_bdcad_couleur'
const MaxExtent = [2532500, 1149000, 2545625, 1161000]
// const MAX_EX  = [532500, 149000, 545625, 161000]; // lidar 2012
const lausanneGare = [2537968.5, 1152088.0]
// const MAX_EXTENT_ASIT_VD = [2420000, 130000, 2900000, 1350000];
proj4.defs('EPSG:2056', '+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs')
proj4.defs('EPSG:21781', '+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=600000 +y_0=200000 +ellps=bessel +towgs84=674.4,15.1,405.3,0,0,0,0 +units=m +no_defs')

register(proj4)
const swissProjection = new OlProjection({
  code: 'EPSG:2056',
  extent: MaxExtent,
  units: 'm'
})
const parser = new OlFormatWMTSCapabilities()

const thousandSep = x => x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, '\'')
// Conv4326In21781 : convert x,y Point in WGS84 Lon,Lat in MN03 (ancien systeme CH) array [x,y]
export const Conv4326In21781 = (x, y) => {
  const projSource = new proj4.Proj('EPSG:4326')
  const projDest = new proj4.Proj('EPSG:21781')
  const Pos = proj4.transform(projSource, projDest, [x, y])
  return [Pos.x, Pos.y]
}
// Conv4326In2056 : convert x,y Point in WGS84 Lon,Lat in MN95  array [x,y]
export const Conv4326In2056 = (x, y) => {
  const projSource = new proj4.Proj('EPSG:4326')
  const projDest = new proj4.Proj('EPSG:2056')
  const Pos = proj4.transform(projSource, projDest, [x, y])
  return [Pos.x, Pos.y]
}
export const Conv2056In4326 = (x, y) => {
  console.log(`#in Conv2056In4326(${x}, ${y})`)
  const projSource = new proj4.Proj('EPSG:2056')
  const projDest = new proj4.Proj('EPSG:4326')
  const Pos = proj4.transform(projSource, projDest, [x, y])
  return [Pos.x, Pos.y]
}
export const Conv2056In21781 = (x, y) => {
  console.log(`#in Conv2056In21781(${x}, ${y})`)
  const projSource = new proj4.Proj('EPSG:2056')
  const projDest = new proj4.Proj('EPSG:21781')
  const Pos = proj4.transform(projSource, projDest, [x, y])
  return [Pos.x, Pos.y]
}
export const Conv21781In2056 = (x, y) => {
  console.log(`#in Conv21781In2056(${x}, ${y})`)
  const xNumber = Number.parseInt(x, 10)
  const yNumber = Number.parseInt(y, 10)
  console.log(`#in Conv21781In2056 Real number(${xNumber}, ${yNumber})`)
  const projSource = new proj4.Proj('EPSG:21781')
  const projDest = new proj4.Proj('EPSG:2056')
  const Pos = proj4.transform(projSource, projDest, [xNumber, yNumber])
  return [Pos.x, Pos.y]
}
export const Conv21781In4326 = (x, y) => {
  const projSource = new proj4.Proj('EPSG:21781')
  const projDest = new proj4.Proj('EPSG:4326')
  const Pos = proj4.transform(projSource, projDest, [x, y])
  return [Pos.x, Pos.y]
}

export const isItMN03 = (point) => {
  log.t(`point x,y : ${point[0]},${point[1]}`)
  const minX = 2479000.0
  const minY = 1070000.0
  if (point[0] < minX) return true
  if (point[1] < minY) return true
  return false
}

export const dumpLayersInfo = (olMap) => {
  log.t('## ENTERING dumpLayersInfo olMap:', olMap)
  const arrLayers = []
  olMap.getLayers()
    .forEach((layer) => {
      const type = isNullOrUndefined(layer.get('type')) ? layer.type : layer.get('type')
      // const source = layer.getSource();
      // WARNING BIG DANGER: DOES NOT EXIST AFTER A BUILD
      // const sourceType = source.constructor.name;
      const title = layer.get('title')
      const infoLayer = `[${type}] title: ${title} isvisible: ${layer.get('visible')}`
      arrLayers.push(infoLayer)
    })
  arrLayers.reverse()
  log.t('## dumpLayersInfo:arrLayers : ', arrLayers.join('\n'))
  return arrLayers
}

export const getWMSVisibleLayersArray = (olMap) => {
  log.t('## ENTERING getWMSVisibleLayersArray olMap:', olMap)
  const localDebug = false
  const arrWMSVisibleLayers = []
  olMap.getLayers()
    .forEach((layer) => {
      const type = isNullOrUndefined(layer.get('type')) ? layer.type : layer.get('type')
      const source = layer.getSource()
      // WARNING BIG DANGER: DOES NOT EXIST AFTER A BUILD
      // const sourceType = source.constructor.name;
      const title = layer.get('title')
      if ((type === 'wms') && !isNullOrUndefined(title)) {
        arrWMSVisibleLayers.push(layer.getVisible())
        if (localDebug) {
          log.w(`[${source.constructor.name}] title: ${layer.get('title')} isvisible: ${layer.get('visible')}`,
            layer, source)
        }
      }
    })
  arrWMSVisibleLayers.reverse()
  log.t('## getWMSVisibleLayersArray:arrWMSVisibleLayers : ', arrWMSVisibleLayers)
  return arrWMSVisibleLayers
}

function getCoordinatesInfo (x, y) {
  const pos4326 = Conv2056In4326(x, y)
  const pos21781 = Conv2056In21781(x, y)
  let info = `MN95 \t: [${thousandSep(x.toFixed(2))}, ${thousandSep(y.toFixed(2))}],\n`
  info += `MN03 \t: [${pos21781[0].toFixed(2)}, ${pos21781[1].toFixed(2)}],\n`
  info += `WGS84\t: [${pos4326[0].toFixed(5)}, ${pos4326[1].toFixed(5)}]`
  return info
}

function getCoordinatesPoint (x, y) {
  const pos4326 = Conv2056In4326(x, y)
  const pos21781 = Conv2056In21781(x, y)
  const info = {
    x: +x.toFixed(2),
    y: +y.toFixed(2),
    mn03_x: +pos21781[0].toFixed(2),
    mn03_y: +pos21781[1].toFixed(2),
    wgs84_lon: +pos4326[0].toFixed(5),
    wgs84_lat: +pos4326[1].toFixed(5)
  }
  return info
}

function getCoordinatesInfoHtml (x, y, lvisibles, baseLayer = defaultBaseLayer) {
  const pos4326 = Conv2056In4326(x, y)
  const pos21781 = Conv2056In21781(x, y)
  const urlCenter = `?x=${x.toFixed(2)}&y=${y.toFixed(2)}&zoom=7&lvisibles=${lvisibles}&baselayer=${baseLayer}`
  // @46.5378031,6.6381231,110m/data=!3m1!1e3
  const urlGoogle = `https://www.google.ch/maps/@${pos4326[1]},${pos4326[0]},110m/data=!3m1!1e3`
  let info = '<table><tbody><tr><td style="width: 9rem">'
  info += '<a target="_blank" href="https://www.swisstopo.admin.ch/fr/connaissances-faits/mensuration-geodesie/cadres-de-reference/local/mn95.html">CH1903+/LV95</a>&nbsp;:'
  info += '</td><td>'
  info += `<a title="recentrer ici" href="${urlCenter}">`
  info += `${thousandSep(x.toFixed(2))}, ${thousandSep(y.toFixed(2))}</a>\n`
  info += '</td></tr><tr><td>'
  info += '<a target="_blank" href="https://www.swisstopo.admin.ch/fr/connaissances-faits/mensuration-geodesie/cadres-de-reference/local/mn03.html">CH1903/LV03</a>&nbsp;:'
  info += '</td><td>'
  info += `${pos21781[0].toFixed(2)}, ${pos21781[1].toFixed(2)}\n`
  info += '</td></tr><tr><td>'
  info += '<a target="_blank" href="https://en.wikipedia.org/wiki/World_Geodetic_System">WGS84&nbsp;(lat,lon)</a>&nbsp;:'
  info += '</td><td>'
  info += `<a target="google" title="google maps" href="${urlGoogle}">${pos4326[1].toFixed(6)},&nbsp;${pos4326[0].toFixed(6)}</a>`
  info += '</td></tr></tbody></table>'
  return info
}

export const getPolygonStyle = (
  feature, resolution,
  options = {
    fill_color: 'rgba(255, 0, 0, 0.8)',
    stroke_color: '#191aff',
    stroke_width: 3
  }
) => {
  const localDebug = false
  if (localDebug) log.t('## Entering getPolygonStyle with feature :', feature)
  if (localDebug) log.l(`resolution : ${resolution}`)

  let props = null
  let theStyle = null
  if (!isNullOrUndefined(feature) && !isNullOrUndefined(feature.getProperties())) {
    props = feature.getProperties()
    const id = isNullOrUndefined(props.id) ? '#INCONNU#' : props.id
    if (localDebug) log.l(`id : ${id}`)
    theStyle = new OlStyle({
      fill: new OlFill({
        color: isNullOrUndefined(props.fill_color) ? options.fill_color : props.fill_color
      }),
      stroke: new OlStroke({
        color: isNullOrUndefined(props.stroke_color) ? options.stroke_color : props.stroke_color,
        width: isNullOrUndefined(props.stroke_width) ? options.stroke_width : props.stroke_width
      }),
      image: new OlCircle({
        radius: isNullOrUndefined(props.stroke_width) ? options.stroke_width : props.stroke_width,
        fill: new OlFill({
          color: isNullOrUndefined(props.fill_color) ? options.fill_color : props.fill_color
        })
      })
    })
  } else {
    theStyle = new OlStyle({
      fill: new OlFill({
        color: options.fill_color // 'rgba(255, 0, 0, 0.8)',
      }),
      stroke: new OlStroke({
        color: options.stroke_color, // '#191aff',
        width: options.stroke_width
      }),
      image: new OlCircle({
        radius: 9,
        fill: new OlFill({
          color: '#ffcc33'
        })
      })
    })
  }
  return theStyle
}

export const setBaseLayer = (olMap, baseLayerName) => {
  log.t(`setBaseLayer(${baseLayerName})`)
  const localDebug = false
  let isBaseLayerNameFound = false
  olMap.getLayers()
    .forEach((layer) => {
      const type = isNullOrUndefined(layer.get('type')) ? layer.type : layer.get('type')
      const source = layer.getSource()
      if (type === 'base') {
        const currentBaseLayer = source.getLayer()
        if (currentBaseLayer === baseLayerName) {
          layer.setVisible(true)
          isBaseLayerNameFound = true
        } else {
          layer.setVisible(false)
        }
        if (localDebug) {
          log.w(`layers : ${currentBaseLayer} [${type}]
                 title : ${layer.get('title')}
                 isvisible: ${layer.get('visible')}`, layer, source)
        }
      }
    })
  if (!isBaseLayerNameFound) {
    log.w(`WARNING : The layer ${baseLayerName} was not found ! SETTING DEFAULT ${defaultBaseLayer} TO VISIBLE `)
    setBaseLayer(olMap, defaultBaseLayer)
  }
}

export const GotoExtent = (olMap, arrExtent) => {
  const localDebug = true
  if (localDebug) log.t('# gotoExtent', arrExtent)
  if (!isNullOrUndefined(arrExtent)) {
    if (localDebug) {
      log.t(`# gotoExtent MIN(x,y) = (${arrExtent[0]},${arrExtent[1]})
        Max(x,y) = (${arrExtent[2]},${arrExtent[3]})`)
    }
    // just in case ...
    const extent = [
      Number.parseInt(arrExtent[0], 10),
      Number.parseInt(arrExtent[1], 10),
      Number.parseInt(arrExtent[2], 10),
      Number.parseInt(arrExtent[3], 10)
    ]
    if (localDebug) log.t('# gotoExtent', extent)
    olMap.getView().fit(extent, olMap.getSize())
  }
}

async function getWMTSCapabilitiesFromUrl (url) {
  const response = await fetch(url)
  if (!response.ok) {
    const message = `###!### ERROR in getWMTSCapabilitiesFromUrl when doing fetch(${url}: http status: ${response.status}`
    throw new Error(message)
  }
  const WMTSCapabilities = await response.text()
  return WMTSCapabilities
}

function getReframeUrl (paramreframe, x, y) {
  const xNumber = Number.parseFloat(x)
  const yNumber = Number.parseFloat(y)
  return `https://geodesy.geo.admin.ch/reframe/${paramreframe}?easting=${xNumber}&northing=${yNumber}&format=json`
}

// eslint-disable-next-line no-unused-vars
async function getConfederateReframeMN03 (x, y) {
  log.l(`## ENTERING getConfederateReframeMN03 x:${x},y:${y}`)
  const url = getReframeUrl('lv95tolv03', x, y)
  const response = await fetch(url, { mode: 'cors' })
  if (!response.ok) {
    const message = `###!### ERROR in getConfederateReframeMN03 when doing fetch(${url}: http status: ${response.status}`
    throw new Error(message)
  }
  const data = await response.json()
  const pointMN03 = [Number.parseFloat(data.easting, 10), Number.parseFloat(data.northing, 10)]
  log.l(`## after await response.text getConfederateReframeMN03 x,y = ${pointMN03[0]},${pointMN03[0]} data: `, data)
  return pointMN03
}
// eslint-disable-next-line no-unused-vars
async function getConfederateReframeMN95 (x, y) {
  log.l(`## ENTERING getConfederateReframeMN03 x:${x},y:${y}`)
  const url = getReframeUrl('lv03tolv95', x, y)
  const response = await fetch(url, { mode: 'cors' })
  if (!response.ok) {
    const message = `###!### ERROR in getConfederateReframeMN03 when doing fetch(${url}: http status: ${response.status}`
    throw new Error(message)
  }
  const data = await response.json()
  const pointMN03 = [Number.parseFloat(data.easting, 10), Number.parseFloat(data.northing, 10)]
  log.l(`## after await response.text getConfederateReframeMN03 x,y = ${pointMN03[0]},${pointMN03[0]} data: `, data)
  return pointMN03
}

function getWmtsSource (WMTSCapabilitiesParsed, layerName) {
  const localDebug = false
  if (localDebug) log.t(`layerName: ${layerName}`)
  const WMTSOptions = optionsFromCapabilities(WMTSCapabilitiesParsed, {
    layer: layerName,
    matrixSet: 'EPSG2056',
    format: 'image/png',
    style: 'default',
    crossOrigin: 'anonymous'
  })
  return new OlSourceWMTS(WMTSOptions)
}

function createBaseOlLayerTile (parsedWmtsCapabilities, title, layerName, visible = false) {
  return new OlLayerTile({
    title,
    type: 'base',
    visible,
    source: getWmtsSource(parsedWmtsCapabilities, layerName)
  })
}

async function getWmtsBaseLayers (url) {
  const arrWmtsLayers = []
  try {
    const WMTSCapabilities = await getWMTSCapabilitiesFromUrl(url)
    const WMTSCapabilitiesASIT = await getWMTSCapabilitiesFromUrl(urlASITVD)
    const WMTSCapabilitiesSWISSTOPO = await getWMTSCapabilitiesFromUrl(urlSWISSTOPO)

    const WMTSCapabilitiesParsed = parser.read(WMTSCapabilities)
    console.log(`## in getWmtsBaseLayers(${url} : WMTSCapabilitiesParsed : \n`, WMTSCapabilitiesParsed)
    const WMTSCapabilitiesParsedASIT = parser.read(WMTSCapabilitiesASIT)
    console.log(`## in getWmtsBaseLayers(${urlASITVD} : WMTSCapabilitiesParsedASIT : \n`, WMTSCapabilitiesParsedASIT)
    const WMTSCapabilitiesParsedSWISSTOPO = parser.read(WMTSCapabilitiesSWISSTOPO)
    console.log(`## in getWmtsBaseLayers(${urlSWISSTOPO} : WMTSCapabilitiesParsed_SWISSTOPO : \n`, WMTSCapabilitiesParsedSWISSTOPO)
    arrWmtsLayers.push(createBaseOlLayerTile(
      WMTSCapabilitiesParsedASIT,
      'Fond Cadastral ASIT VD',
      'asitvd.fond_cadastral',
      (defaultBaseLayer === 'asitvd.fond_cadastral')
    ))
    arrWmtsLayers.push(createBaseOlLayerTile(
      WMTSCapabilitiesParsedSWISSTOPO,
      'Carte Nationale 1:25\'000 (SWISSTOPO)',
      'ch.swisstopo.pixelkarte-farbe-pk25.noscale',
      (defaultBaseLayer === 'ch.swisstopo.pixelkarte-farbe-pk25.noscale')
    ))
    arrWmtsLayers.push(createBaseOlLayerTile(
      WMTSCapabilitiesParsedSWISSTOPO,
      'SwissImage 2020 10cm (SWISSTOPO)',
      'ch.swisstopo.swissimage',
      (defaultBaseLayer === 'ch.swisstopo.swissimage')
    ))
    arrWmtsLayers.push(createBaseOlLayerTile(
      WMTSCapabilitiesParsed,
      'Orthophoto 2016 (Lausanne)',
      'orthophotos_ortho_lidar_2016',
      (defaultBaseLayer === 'orthophotos_ortho_lidar_2016')
    ))
    arrWmtsLayers.push(createBaseOlLayerTile(
      WMTSCapabilitiesParsed,
      'Fond cadastral (Lausanne)',
      'fonds_geo_osm_bdcad_gris',
      (defaultBaseLayer === 'fonds_geo_osm_bdcad_gris')
    ))
    arrWmtsLayers.push(createBaseOlLayerTile(
      WMTSCapabilitiesParsed,
      'Plan ville (Lausanne)',
      'fonds_geo_osm_bdcad_couleur',
      (defaultBaseLayer === 'fonds_geo_osm_bdcad_couleur')
    ))
    return arrWmtsLayers
  } catch (err) {
    const message = `###!### ERROR in getWmtsBaseLayers occured with url:${url}: error is: ${err}`
    console.warn(message)
    return []
  }
}

export const createNewWMSLayer = (layerName, layerTitle, isVisible, serverUrl = baseWmsUrl) => {
  if (isNullOrUndefined(layerName) || isNullOrUndefined(layerTitle)) {
    log.e(`## ERROR in createNewWMSLayer the parameters layerName, layerTitle should not be null or undefined !
    layerName = ${layerName} and layerTitle =${layerTitle}`)
    return null
  }
  const tmpLayer = new OlLayerImage({
    title: layerTitle,
    type: 'wms',
    visible: isVisible,
    source: new OlSourceImageWMS({
      crossOrigin: 'anonymous',
      params: { LAYERS: layerName, ogcserver: 'source for image/png' },
      serverType: 'mapserver',
      url: serverUrl
    })
  })
  // log.t(`## IN createNewWMSLayer(${layerName})`, tmpLayer);
  return tmpLayer
}

export const createIconStyleCenterCenter = imagePath => new OlStyle({
  image: new OlStyleIcon({ // http://openlayers.org/en/latest/apidoc/ol.style.Icon.html
    src: imagePath,
    opacity: 1.0,
    anchor: [0.5, 0.5] // we want the marker to be centered
  })
})

export const getLayerByName = (olMap, layerName) => {
  const layerFound = []
  olMap.getLayers().forEach((layer) => {
    if (layer.get('name') !== undefined && layer.get('name') === layerName) {
      layerFound.push(layer)
    }
  })
  if (layerFound.length > 0) {
    return layerFound[0]
  }
  return null
}

export const getVectorSourceGeoJson = (geoJsonData) => {
  log.t('## in getVectorSourceGeoJson ')
  return new OlSourceVector({
    format: new OlFormatGeoJSON({
      defaultDataProjection: 'EPSG:2056',
      projection: 'EPSG:2056'
    }),
    features: (new OlFormatGeoJSON()).readFeatures(geoJsonData)
  })
}

export const loadWMSLayers = (olMap, layersconfig) => {
  log.t('## ENTERING loadWMSLayers layersconfig:', layersconfig)
  if (!isNullOrUndefined(layersconfig.wmsLayers)) {
    const numLayers = layersconfig.wmsLayers.length
    log.l(`Found ${numLayers} wms layers to load `)
    for (let i = (numLayers - 1); i > -1; i -= 1) {
      const wmslayer = layersconfig.wmsLayers[i]
      olMap.addLayer(createNewWMSLayer(
        wmslayer.layers,
        wmslayer.title,
        wmslayer.isVisible
      ))
    }
  }
}

export async function createLausanneMap (
  divOfMap, centerOfMap = lausanneGare,
  zoomLevel = 16,
  iddiv = null,
  mapExtent = null,
  displayPointInfo = false,
  layersconfig = null,
  callbackClick = null
) {
  log.t(`createLausanneMap(x,y: [${centerOfMap[0]},${centerOfMap[1]}]  zoom:${zoomLevel})`, mapExtent, layersconfig)
  let realCenter = centerOfMap
  if (isItMN03(centerOfMap)) {
    realCenter = Conv21781In2056(centerOfMap[0], centerOfMap[1])
    log.w(`POINT WAS GIVEN  IN MN03 so converrted in MN95: realCenter : (${realCenter[0]},${realCenter[1]})`)
    // realCenter = await getConfederateReframeMN95(centerOfMap[0], centerOfMap[1]);
    // const posMN95 = await getConfederateReframeMN03(2537911.454, 1152755.107);
    // log.w(`CONVERSION MN03-MN95 : 2537911.454,1152755.107 -> : (${posMN95[0]},${posMN95[1]})`);
  }
  const arrBaseLayers = await getWmtsBaseLayers(urlLausanneMN95)
  if ((arrBaseLayers === null) || (arrBaseLayers.length < 1)) {
    log.w('arrBaseLayers cannot be null or empty to be able to see a nice map !')
    return null
  }
  const map = new OlMap({
    target: divOfMap,
    layers: arrBaseLayers,
    view: new OlView({
      projection: swissProjection,
      center: realCenter,
      zoom: zoomLevel
    })
  })
  const layerCenterPoint = new OlLayerVector({
    type: 'center',
    source: new OlSourceVector({
      features: []
    })
  })
  const layerSwitcher = new LayerSwitcher({
    tipLabel: 'Légende', // Optional label for button
    groupSelectStyle: 'children' // Can be 'children' [default], 'group' or 'none'
  })
  map.addControl(layerSwitcher)
  const popup = new Popup()
  map.addOverlay(popup)
  if (!isNullOrUndefined(mapExtent)) {
    if (isItMN03([mapExtent[0], mapExtent[1]])) {
      const minPoint = Conv21781In2056(mapExtent[0], mapExtent[1])
      const maxPoint = Conv21781In2056(mapExtent[2], mapExtent[3])
      const realmapExtent = [minPoint[0], minPoint[1], maxPoint[0], maxPoint[1]]
      GotoExtent(map, realmapExtent)
    } else {
      GotoExtent(map, mapExtent)
    }
  } else {
    log.l(`-->CenterPoint choosed : realCenter(${realCenter[0]},${realCenter[1]})`)
    layerCenterPoint.getSource().clear()
    const newPlace = new OlFeature(new OlPoint(realCenter))
    newPlace.setStyle(createIconStyleCenterCenter(`${BASE_PATH}clic_point.png`))
    layerCenterPoint.getSource().addFeature(newPlace)
  }
  let lausanneBaseLayer = defaultBaseLayer
  let layerForQuery = 'bdcad_bf_parc_pol,bdcad_bf_parc_pol_dp,bdcad_bf_parc_pol_ddp,bdcad_cs_bati_pol,bdcad_cs_bati_pol_sout'
  if (!isNullOrUndefined(layersconfig)) {
    layerForQuery = createNewWMSLayer(layersconfig.layerForQueryInit, 'Query', false)
    if (!isNullOrUndefined(layersconfig.baseLayer)) {
      lausanneBaseLayer = layersconfig.baseLayer
    }
    setBaseLayer(map, lausanneBaseLayer)
    loadWMSLayers(map, layersconfig)
  }
  map.VDL_layerForQuery = layerForQuery
  map.addLayer(layerCenterPoint)
  dumpLayersInfo(map)
  const visibleWMSLayers = getWMSVisibleLayersArray(map)
  const lvisibles = arrBoolToHex(visibleWMSLayers)
  // MAP EVENTS
  map.on('click', async (evt) => {
    const x = Number(evt.coordinate[0])
    const y = Number(evt.coordinate[1])
    const pos2056 = [x, y]
    const info = getCoordinatesInfo(x, y)
    // const posMn03 = await getConfederateReframeMN03(x, y);
    const posMn03 = Conv2056In21781(x, y)
    log.l(`#in olmap.click at x,y : [${x.toFixed(2)}, ${y.toFixed(2)}]\n${info}`, posMn03)
    layerCenterPoint.getSource().clear()
    const newPlace = new OlFeature(new OlPoint(pos2056))
    newPlace.setStyle(createIconStyleCenterCenter('clic_point.png'))
    layerCenterPoint.getSource().addFeature(newPlace)
    const pointCoordInfo = getCoordinatesPoint(x, y)
    // on recupere les infos plus precises de reframe de la confed
    // eslint-disable-next-line prefer-destructuring
    pointCoordInfo.mn03_x = posMn03[0]
    // eslint-disable-next-line prefer-destructuring
    pointCoordInfo.mn03_y = posMn03[1]
    if (!isNullOrUndefined(callbackClick)) {
      if (functionExist(callbackClick)) {
        callbackClick(pointCoordInfo)
      }
    }
    if (displayPointInfo) {
      const infoHTML = getCoordinatesInfoHtml(x, y, lvisibles, lausanneBaseLayer)
      popup.show(
        pos2056,
        `<div id='map-popup'><h4>Coordonnées:</h4>${infoHTML}</div>`
      )
    }
  })

  if (!isNullOrUndefined(iddiv)) {
    log.l('iddiv : ', iddiv)
    const divToc = getEl(iddiv)
    log.l('divToc : ', divToc, map)
    LayerSwitcher.renderPanel(map, divToc)
  }
  // on ajoute la ref a layerswitcher a l'objet olMap['myref2LayerSwitcher'] pour usage ultérieur
  map.myref2LayerSwitcher = layerSwitcher

  return map
}



// WEBPACK FOOTER //
// ./src/components/cgil-vue-olmap/ol-lausanne-map-mn95.js